module.exports = __webpack_public_path__ + "static/media/vis1.dca60c0a.jpeg";